import { useState, useCallback } from 'react';
import axios from 'axios';
import { KpiData } from '../types';
import { API_BASE } from '../constants';

export interface JournalKpiState {
  kpi: KpiData | null;
  kpiLoading: boolean;
  fetchKpi: () => Promise<void>;
}

/**
 * Загружает KPI-агрегаты для одной аптеки.
 * Принимает те же фильтры что useJournalEntries.
 */
export function useJournalKpi(
  pharmacyGuid: string,
  filterParams: Record<string, string>,
): JournalKpiState {
  const [kpi, setKpi] = useState<KpiData | null>(null);
  const [kpiLoading, setKpiLoading] = useState(true);

  const fetchKpi = useCallback(async () => {
    if (!pharmacyGuid) return;
    setKpiLoading(true);
    try {
      const resp = await axios.get(`${API_BASE}/journal-user/analytics/summary`, {
        params: { pharmacyGuid, ...filterParams },
      });
      if (resp.data?.success) {
        setKpi(resp.data.data);
      }
    } catch (e) {
      console.error('KPI fetch error:', e);
    } finally {
      setKpiLoading(false);
    }
  }, [pharmacyGuid, filterParams]);

  return { kpi, kpiLoading, fetchKpi };
}
